import { useContext } from "react";
import App from "../app";
import { Constructor } from "../stores/RootStore";

export function useStore<TStore>(whichStore: Constructor<TStore>): TStore {
    return useContext(App.RootStoreContext()).getStore<TStore>(whichStore);
}
